import { render } from "./GuessTheBalanceDetailsPage.vue?vue&type=template&id=6b0fefc6&scoped=true"
import script from "./GuessTheBalanceDetailsPage.vue?vue&type=script&lang=js"
export * from "./GuessTheBalanceDetailsPage.vue?vue&type=script&lang=js"

import "./GuessTheBalanceDetailsPage.vue?vue&type=style&index=0&id=6b0fefc6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0fefc6"]])

export default __exports__